import { render, staticRenderFns } from "./crudActivity.vue?vue&type=template&id=1cfc61b6&scoped=true&"
import script from "./crudActivity.vue?vue&type=script&lang=js&"
export * from "./crudActivity.vue?vue&type=script&lang=js&"
import style0 from "./crudActivity.vue?vue&type=style&index=0&id=1cfc61b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc61b6",
  null
  
)

export default component.exports